var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSwjwHomepage(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "SwjwHomepage_svg__icon",
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1013.5 389.1c-4.8-9.9-11.7-18.6-20.4-25.5L583.9 37.9C543.8 6 486.9 6 446.8 38L33.6 366.1c-15 12.4-27.3 26.3-27.3 45.9v36.6c0 27.8 22.5 50.3 50.3 50.3 27.8 0 50.3-22.5 50.3-50.3 0-6.7 3.1-13 8.3-17.2l373-296.9c16-12.8 38.8-12.8 54.8 0l371 295.2c3.6 2.8 5.6 7.2 5.6 11.7v7.2c0 27.8 22.5 50.3 50.3 50.3 27.8 0 50.3-22.5 50.3-50.3V412c.1-6.8-3.1-15.4-6.7-22.9z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M872.7 437.9L541 173.7c-15.8-12.6-38.3-12.6-54.1 0L155.2 437.9c-11.3 9-17.9 22.7-17.9 37.2v484.1c0 27.4 22.2 49.5 49.5 49.5h196.3v-279c0-21.4 17.4-38.8 38.8-38.8h181.9c21.4 0 38.8 17.4 38.8 38.8v279h198.5c27.4 0 49.5-22.2 49.5-49.5V475.1c0-14.4-6.6-28.1-17.9-37.2z",
    fill: "#fff"
  })));
}
export default SvgSwjwHomepage;